export default __webpack_public_path__ + "static/media/PessoasSegurandoKahsh.9bc9721f.svg";